<template>
  <div class="clean-list-box">
    <div class="clean-list__header">
      <div class="clean-name">商业公司名称: {{cleanName}}</div>
      <div class="clean-count count-num" v-if="!loading && data.length !== 0">精确搜索出 <span class="blue">{{cleanCount}}</span> 个结果</div>
    </div>
    <div class="clean-list__content" v-loading="loading">
      <div class="clean-results">
        <div class="clean-list-table" v-if="!loading && data.length !== 0">
          <page-table
            :loading="loading"
            :col="col"
            :data="data"
            :hasFixed="true"
            @compFn="compFn"
          ></page-table>
        </div>
        <div class="clean-no-result" v-if="!loading && data.length === 0">共有0个结果</div>
      </div>
      <clean-search
        ref="cleanSearch"
        v-if="!loading && data.length === 0"
        @toggleDelDiag="toggleDelDiag"
        @updateSel="updateSel"
      ></clean-search>
    </div>
    <div class="clean-list__fixed page-fixed">
      <Button type="primary" @click.stop="setDeal">已处理</Button>
      <Button @click.stop="setUnsure">不确定</Button>
    </div>
    <simple-diag
      :isShow="delDiag"
      :title="'删除'"
      :width="'400px'"
      :content="'确定删除吗？'"
      @confirm="confirmDel"
      @close="toggleDelDiag(false)"
    ></simple-diag>
  </div>
</template>

<script>
import Vue from 'vue'
import simpleDiag from '@/components/dialogs/simpleDiag'
import pageTable from '@/components/pageCom/pageTable'
import cleanSearch from './components/cleanSearch'
export default {
  components: { cleanSearch, pageTable, simpleDiag },
  data() {
    return {
      cleanName: '安徽海王国安医药有限公司',
      cleanCount: '',
      col: [],
      data: [],
      loading: false,
      selIndex: '', // 选中的id
      delIndex: '', // 删除的条id
      delDiag: false
    }
  },
  mounted() {
    this.$store.dispatch('setPage', {
      title: '单条清洗',
      url: '',
      type: 'cover card-footer'
    })
    this.getTabelData()
  },
  methods: {
    // 获取结果
    getTabelData() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.cleanCount = Math.floor(Math.random() * 100)
        this.col = [
          { field: 'radio', title: '选择', width: 50, titleAlign: 'left', columnAlign: 'left', componentName: 'cleanListRadio' },
          { field: 'operate', title: '操作', width: 90, titleAlign: 'left', columnAlign: 'left', componentName: 'cleanListOpe' },
          { field: 'name', title: '姓名', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'tel', title: '手机号码', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'hobby', title: '爱好', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
          { field: 'address', title: '地址', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' }
        ]
        this.data = [
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' },
          { isSel: false, name: '赵伟', tel: '156*****1987', hobby: '钢琴、书法、唱歌', address: '上海市黄浦区金陵东路569号17楼' }
        ]
        this.data = []
      }, 500)
    },
    pageChange() {
    },
    pageSizeChange() {
    },
    // 删除弹框
    toggleDelDiag(flag) {
      this.delDiag = flag
    },
    // 确认删除
    confirmDel() {
      if (this.data.length !== 0) {
        this.getTabelData()
      } else {
        this.$refs.cleanSearch && this.$refs.cleanSearch.search()
      }
      this.toggleDelDiag(false)
    },
    // 更新选中id
    updateSel(index) {
      this.selIndex = index
    },
    // 标记已处理
    setDeal() {
    },
    // 不确定
    setUnsure() {
    },
    // 表格内操作
    compFn(params) {
      if (params.type === 'del') {
        this.toggleDelDiag(true)
      } else if (params.type === 'setRadio') {
        this.updateSel(params.index)
        this.data.map((item, index) => {
          item.isSel = index === params.index
        })
      }
    }
  }
}
// 自定义列组件
Vue.component('cleanListRadio', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    setRadio() {
      this.$emit('on-custom-comp', {
        type: 'setRadio',
        index: this.index
      })
    }
  },
  render: function(h) {
    return h('div', {
      class: ['ivu-radio', this.rowData.isSel ? 'ivu-radio-checked' : ''],
      on: {
        click: this.setRadio
      }
    }, [
      h('span', {
        class: 'ivu-radio-inner'
      })
    ])
  }
})
// 自定义列组件
Vue.component('cleanListOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    edit() {
      this.$router.push({
        name: 'editLib', params: { id: this.index }
      })
    },
    del() {
      this.$emit('on-custom-comp', {
        type: 'del',
        index: this.index
      })
    }
  },
  render: function(h) {
    return h('div', {
      class: 'operate'
    }, [
      h('span', {
        class: 'link-btn',
        on: {
          click: this.edit
        }
      }, '编辑'),
      h('a', {
        class: 'link-btn link-btn-red',
        on: {
          click: this.del
        }
      }, '删除')
    ])
  }
})
</script>
<style lang="scss" scoped="">
  .clean-list__header {
    margin-bottom: 18px;
    position: relative;
  }
  .clean-list__content {
    min-height: 174px;
  }
  .clean-list__fixed {
    .ivu-btn {
      width: 69px;
    }
  }
  .clean-no-result {
    height: 70px;
    line-height: 70px;
    text-align: center;
    background: #F3F6F8;
    color: #748BA3;
    margin-bottom: 24px;
  }
</style>
